import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { dataActions } from "../../store/data-slice";
import { toggleActions } from "../../store/toggle-slice";
import { screenActions } from "../../store/screens-slice";
import { stepperActions } from "../../store/stepper-slice";
import { formatDate } from "../../helpers/formatDate";
import { useWindowDimensions } from "../../hooks/useWindowDimensions";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

import { motion } from "framer-motion";

import "./Element.css";

import Checkbox from "react-simple-checkbox";
import { useTranslation } from "react-i18next";

import { SlideDown } from "react-slidedown";
import "react-slidedown/lib/slidedown.css";

/*
  ELEMENT:
    - responsable of showing fecha information (plazas, fecha, horario, seleccionar, eliminar, continuar, volver, incrementar número de personas)
*/
const Element = ({
  data,
  screen,
  tipo = null,
  handleClass,
  classes,
  month,
}) => {
  const [toggleSelectButton, setToggleSelectButton] = useState(true);
  const [toggleBottomDiv, settoggleBottomDiv] = useState(false);
  const [personsNumber, setPersonsNumber] = useState(1);
  const [checkStreaming, setCheckStreaming] = useState(false);
  const [checkPresencial, setCheckPresencial] = useState(true);
  const [completo, setCompleto] = useState(false);
  const { width } = useWindowDimensions();

  const { id, fecha, horario, plazas } = data.itm;

  const disableElements = useSelector((state) => state.toggle.disableElements);

  const practicas_data = useSelector((state) => state.data.practicas);
  const teoria_data = useSelector((state) => state.data.teoria);
  const tipoTeoria = useSelector((state) => state.data.tipoTeoria);

  const elementoSeleccionadoEnPracticas = useSelector(
    (state) => state.data.elementoSeleccionadoEnPracticas
  );

  const persons_number = useSelector((state) => state.data.practicas.personas);

  const fechaDespuesValue = useSelector((state) => state.data.fechaDespues);

  const [t, i18n] = useTranslation("global");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(screenActions.setTipo(tipo));
  }, [tipo]);

  useEffect(() => {
    recoverSelectedValues();
  }, [practicas_data, teoria_data]);

  useEffect(() => {
    //if the persons quantity is bigger than the lefted places, the presencial option will be disabled
    //and only the streaming will be available because all available places are full
    if (persons_number > plazas) {
      setCompleto(true);
      setCheckStreaming(true);
      setCheckPresencial(false);
    }
  }, [persons_number]);

  //Recover already selected dates (fechas), for example when you select a date and you go to the next screen
  //but you want to go back the previours screen; this functions helps you to recover the selected value without loosing it
  const recoverSelectedValues = () => {
    let num_personas;
    let selectedeElement;
    if (screen === "practicas") {
      num_personas = practicas_data.personas;
      selectedeElement = Object.values(practicas_data.data);
    } else if (screen === "teoria") {
      num_personas = teoria_data.personas;
      selectedeElement = Object.values(teoria_data.data);
    }
    if (selectedeElement.length > 0) {
      if (selectedeElement[0] == id) {
        handleClass(selectedeElement[0]);
        applyChanges(true, true);
        setPersonsNumber(num_personas);
      }
    }
    if (tipoTeoria === "Streaming") {
      setCheckStreaming(true);
      setCheckPresencial(false);
    } else {
      setCheckStreaming(false);
      setCheckPresencial(true);
    }
  };

  //Handle the selected fecha by saving it's id value, check if it with a date (con_fecha) or without it (Elegiré fecha después) and disable other elements (dates/fechas)
  //so that only one can be selected at once
  const handleSelect = () => {
    handleClass(id, tipo);
    applyChanges(true, true);

    if (screen === "practicas") {
      dispatch(screenActions.setScrollDivPracticas(`#element_${id}`));
      dispatch(screenActions.setMonthSelected(""));
    } else if (screen === "teoria") {
      dispatch(screenActions.setScrollDivTeoria(`#element_${id}`));
    }

    if (screen === "practicas") {
      dispatch(dataActions.elementoSeleccionadoEnPracticas("con_fecha"));
    } else if (screen === "teoria") {
      dispatch(dataActions.elementoSeleccionadoEnTeoria("con_fecha"));
    }
  };

  //Remove all saved values from the selected item (date/fecha)
  const handleRemove = () => {
    handleClass(-1);
    applyChanges(false, false);
    if (screen === "practicas") {
      dispatch(dataActions.elementoSeleccionadoEnPracticas(""));
      dispatch(
        dataActions.applyPracticas({
          personas: 1,
          periodo: tipo,
          data: {},
        })
      );
    } else if (screen === "teoria") {
      dispatch(dataActions.elementoSeleccionadoEnTeoria(""));
      dispatch(
        dataActions.applyTeoria({
          personas: 1,
          data: {},
        })
      );
      dispatch(dataActions.setTipoTeoria("Streaming"));
    }
  };

  //Toggle tipo de teoria
  //if streaming is selected unselect prensencial
  const handleOnChangeStreaming = (e) => {
    setCheckStreaming(!checkStreaming);
    setCheckPresencial(!checkPresencial);
    dispatch(dataActions.setTipoTeoria("Streaming"));
  };

  //if streaming is selected unselect prensencial
  const handleOnChangePresencial = (e) => {
    setCheckStreaming(!checkStreaming);
    setCheckPresencial(!checkPresencial);
    dispatch(dataActions.setTipoTeoria("Presencial"));
  };

  //Disable all elements and items of the app when a date is selected
  const applyChanges = (disableClassValue, disableFechaDespuesValue) => {
    setToggleSelectButton(!toggleSelectButton);
    settoggleBottomDiv(!toggleBottomDiv);
    dispatch(toggleActions.disableClass(disableClassValue));
    dispatch(toggleActions.disableFechaDespues(disableFechaDespuesValue));
  };

  let toggleButtons;

  if (screen == "practicas") {
    toggleButtons = true;
  } else if (screen === "teoria") {
    toggleButtons = false;
  }

  //Moove the next screen and save the values of the selected date
  const handleNextScreen = () => {
    //check the main displayed screen of the app is practicas
    if (screen == "practicas") {
      dispatch(dataActions.setFechaDespues(null)); //set fechadespues to null because a date has been selected and not (Elegiré fecha después)
      dispatch(
        dataActions.applyPracticas({
          personas: personsNumber,
          periodo: tipo,
          data: {
            id,
            fecha,
            horario,
            plazas,
          },
        })
      );
      dispatch(screenActions.setMainScreen("teoria")); //set the main screen of the app to Teoria
      dispatch(stepperActions.setActiveStep(1)); //set the active stepper to teoria (position 1 of the stepper array --> check "Stepper" component!)
    }
    //check the main displayed screen of the app is teoria
    else if (screen === "teoria") {
      dispatch(
        dataActions.applyTeoria({
          personas: personsNumber,
          data: {
            id,
            fecha,
            horario,
            plazas,
          },
        })
      );
      dispatch(screenActions.setMainScreen("extras"));
      dispatch(stepperActions.setActiveStep(2)); //set the active stepper to teoria (position 2 of the array --> check "Stepper" component!)
    }

    //Active all classes so that all items can be clicable
    dispatch(toggleActions.disableClass(false));
    dispatch(toggleActions.disableElements(false));
    dispatch(toggleActions.disableFechaDespues(false));

    // Set the inputs of the form to empty to later fill them with the correct values
    const limitEC = Math.ceil(persons_number / 4);
    dispatch(dataActions.setExtrasInputListCM(Array(persons_number).fill("")));
    dispatch(dataActions.setExtrasInputListEE(Array(persons_number).fill("")));
    dispatch(dataActions.setExtrasInputListEC(Array(limitEC).fill({})));
  };

  //Go back to the previous screen
  const handleBackScreen = () => {
    /* As long as the Set all values to default */
    dispatch(toggleActions.disableClass(false));
    dispatch(toggleActions.disableFechaDespues(false));
    dispatch(screenActions.setMainScreen("practicas"));
    dispatch(stepperActions.setActiveStep(0));
    dispatch(screenActions.setScrollDivTeoria(""));
    dispatch(dataActions.setFechaDespues(-1)); // if fechaDespuesValue == 0 it means that (Eligiré fecha después) is selected (sin_fecha)
    dispatch(dataActions.setTipoTeoria("Presencial"));

    if (
      //if (Eligiré fecha despues) is not choosen
      fechaDespuesValue == 0 &&
      elementoSeleccionadoEnPracticas == "sin_fecha"
    ) {
      dispatch(toggleActions.disableClass(true));
      dispatch(toggleActions.disableElements(true));
    }

    if (screen === "teoria") {
      dispatch(dataActions.elementoSeleccionadoEnTeoria(""));
      dispatch(
        dataActions.applyTeoria({
          personas: 1,
          data: {},
        })
      );
    }
  };

  let places_string;

  const { language } = i18n;

  if (language == "en") {
    if (plazas === 1) {
      //Example: 1 place left
      places_string = `${plazas} ${t("ELEMENT.places.sing")} ${t(
        "ELEMENT.places.remain_s"
      )}`;
    } else {
      //5 places left
      places_string = `${plazas} ${t("ELEMENT.places.plural")} ${t(
        "ELEMENT.places.remain_p"
      )}`;
    }
  } else {
    if (plazas === 1) {
      // Queda 1 plaza
      places_string = `${t("ELEMENT.places.remain_s")} ${plazas} ${t(
        "ELEMENT.places.sing"
      )}`;
    } else {
      // Queda 5 plazas
      places_string = `${t("ELEMENT.places.remain_p")} ${plazas} ${t(
        "ELEMENT.places.plural"
      )}`;
    }
  }

  return (
    <div id={month}>
      <div
        className={
          disableElements
            ? "element__element element__disable"
            : `element__element${classes}`
        }
        id={`element_${id}`}
      >
        <div className="element__top">
          <div className="element__info">
            <p
              className="element__plazasQuedan"
              style={plazas > 3 ? { color: "green" } : null} //change the color to green if plazas > 3, else leave it to red color
            >
              {screen === "practicas" && places_string}
            </p>
            <p className="element__date">{formatDate(fecha, width, 350)}</p>
            <p className="element__hours">{`${horario[0]} ${
              language == "en" ? "to" : "a"
            } ${horario[1]}`}</p>
          </div>
          <div className="element__selecionarEliminarContainer">
            <div className="element__selectionarEliminar">
              {toggleSelectButton ? (
                <>
                  <p>{t("ELEMENT.button.select")}</p>
                  <button onClick={handleSelect}>
                    <motion.div whileHover={{ scale: 1.1 }}>
                      <AddCircleIcon
                        style={{ color: "#499BB1", fontSize: 60 }}
                      />
                    </motion.div>
                  </button>
                </>
              ) : (
                <>
                  <p>{t("ELEMENT.button.remove")}</p>
                  <button onClick={handleRemove}>
                    <HighlightOffIcon
                      style={{ color: "#499BB1", fontSize: 60 }}
                    />
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        <SlideDown>
          {toggleBottomDiv && (
            <>
              {screen === "teoria" && (
                <div className="element__tipoTeoria">
                  <div className="element__checkContainer">
                    <p>{t("TEORIA.type.presential")}</p>
                    {completo && <span>{t("TEORIA.type.completed")}</span>}
                    <div
                      className={`${
                        completo && "element__checkPresencialCompleto"
                      }`}
                    >
                      <Checkbox
                        checked={checkPresencial}
                        size={4}
                        color="#499BB1"
                        tickAnimationDuration="100"
                        backAnimationDuration="100"
                        onChange={(e) => {
                          handleOnChangePresencial(e);
                        }}
                      />
                    </div>
                  </div>
                  {/* <div className="element__checkContainer">
                    <p>{t("TEORIA.type.streaming")}</p>
                    <Checkbox
                      checked={checkStreaming}
                      size={4}
                      color="#499BB1"
                      tickAnimationDuration="100"
                      backAnimationDuration="100"
                      onChange={(e) => {
                        if (!completo) handleOnChangeStreaming(e);
                      }}
                    />
                  </div> */}
                </div>
              )}
              <div className="element__bottom">
                {toggleButtons ? (
                  <div className="element__icons">
                    <div className="element__profileIcon">
                      <PersonOutlineIcon style={{ fontSize: 30 }} />
                    </div>
                    <div className="element__decrement">
                      <button
                        onClick={() => {
                          setPersonsNumber(personsNumber - 1);
                        }}
                        disabled={personsNumber == 1}
                      >
                        <RemoveCircleOutlineIcon style={{ fontSize: 30 }} />
                      </button>
                    </div>
                    <div className="element__counter">{personsNumber}</div>
                    <div className="element__increment">
                      <button
                        onClick={() => {
                          setPersonsNumber(personsNumber + 1);
                        }}
                        disabled={personsNumber == plazas}
                      >
                        <AddCircleOutlineIcon style={{ fontSize: 30 }} />
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="element__personContainer">
                    <div className="element__profileIcon">
                      <PersonOutlineIcon style={{ fontSize: 30 }} />
                    </div>
                    <div className="element__counter">
                      {practicas_data.personas}
                    </div>
                  </div>
                )}
                <div className="element__buttonsContainer">
                  {!toggleButtons && (
                    <div className="element__volverContainer">
                      <button onClick={handleBackScreen}>
                        {t("ELEMENT.button.back")}
                      </button>
                    </div>
                  )}
                  <div className="element__continueContainer">
                    <button onClick={handleNextScreen}>
                      {t("ELEMENT.button.next")}
                    </button>
                  </div>
                </div>
              </div>
              {/* {screen === "teoria" && !completo && (
                <div className="element__observation">
                  <p>{t("TEORIA.explication")}</p>
                </div>
              )} */}
            </>
          )}
        </SlideDown>
      </div>
    </div>
  );
};

export default Element;
